export var getChartSeriesColors = function getChartSeriesColors(theme) {
  return [theme.colors.primary, theme.colors.secondary, theme.colors.terciary, theme.colors.chart4, theme.colors.chart2, theme.colors.chart3, theme.colors.chart1];
};